export default __webpack_public_path__ + "static/media/Blade of Refectory.2465eb3b.jpg";